import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { toggleAside } from '../../actions/UIActions';
import ImageSearchGroup from './ImageSearchGroup/ImageSearchGroup';
import ListCaption from '../../components/ListCaption';

import { clearImageSelection } from '../../actions/SearchFieldActions';
import { updateEvaluatedImageFilter } from '../../actions/SearchParameter.Actions';
import './Aside.sass';

class Aside extends Component {
  constructor(props) {
    super(props);
    this.handleDirectBatchSearch = this.handleDirectBatchSearch.bind(this);
    this.handleFilterEvaluatedImages = this.handleFilterEvaluatedImages.bind(this);
  }

  handleDirectBatchSearch() {
    const { dispatch, history } = this.props;
    history.push('/images/batch_evaluation');
    dispatch(clearImageSelection());
  }

  handleFilterEvaluatedImages() {
    const { dispatch, filterEvaluatedImage } = this.props;
    dispatch(clearImageSelection());
    dispatch(updateEvaluatedImageFilter(!filterEvaluatedImage));
  }

  render() {
    const { showAside, dispatch } = this.props;

    return (
      <aside className={`Aside ${showAside ? 'show-aside' : ''}`}>
        <div className="app-name-wrapper">
          <h2>Umbo Data Visualization</h2>
        </div>

        <div className="drawer-group">
          <div className="aside-toggle-tag">
            <button onClick={() => dispatch(toggleAside())}>
              <span className="fa fa-chevron-left" /> Collapse
            </button>
          </div>

          <ListCaption>Image Search Parameter</ListCaption>
          <ImageSearchGroup />

          {/* <ListCaption>Video Parameter</ListCaption> */}
        </div>
      </aside>
    );
  }
}

Aside.propTypes = {
  showAside: PropTypes.bool.isRequired,
  filterEvaluatedImage: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(store) {
  const { UI: { showAside }, SearchParameter } = store;

  return {
    showAside,
    filterEvaluatedImage: SearchParameter.evaluatedImageFilter
  };
}

export default withRouter(connect(mapStateToProps)(Aside));



// WEBPACK FOOTER //
// ./src/containers/Aside/Aside.jsx